module.exports = __webpack_public_path__ + "img/3-top-right.53432b3a.png";